import BodyContent from "./Components/BodyContent";
import MainArea from "./Components/MainArea";

function App() {
  return (
    <div className="App">
      <MainArea />
      <BodyContent />
    </div>
  );
}

export default App;
